export const getValueColor = (value: number) => {
  if (value > 0) return 'text-success'
  if (value < 0) return 'text-destructive'
  return ''
}
